module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAHlBMVEVHcExKR0BUVENKRz9KSkFNSEJLSEBKSEBKRz9KRz8QvefRAAAACXRSTlMA3Q/tHi5UebqTL292AAAAgklEQVR42u3PMQ7EMAwDQdqyZen/Hz4gQcCWLA5psvWwIN4vT06Dr+ruSN2PvkrDc6F5LjTPUvQsRc+26btEz1wfpu8yfSzT789//kXPyvRpepTpMUyPMD3C9AjTI0yPMD3C8BzQW4OaEDpPufCXdg2lSl7QCnfQE3cpLg5fTKWb/gAhZR0OM0q6aQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-welfare/member-edit-icon.png
// module id = s0KC
// module chunks = 216